<script setup lang="ts">
import type { cssUnit } from "@/Modules/App/Models/Styles/Css";

export type skeletonType = "text" | "circle";

export interface SkeletonProps {
  width?: number;
  height?: number;
  variant?: skeletonType;
  unitW?: cssUnit;
  unitH?: cssUnit;
}

withDefaults(defineProps<SkeletonProps>(), {
  height: 100,
  width: 100,
  unitW: "%",
  unitH: "%",
  variant: "text",
});
</script>

<template>
  <div
    class="skeleton"
    :class="{ circle: variant === 'circle', text: variant === 'text' }"
    :style="{
      height: `${height}${unitH}`,
      width: `${width}${unitW}`,
    }"
  />
</template>

<style lang="scss">
.skeleton {
  display: block;
  animation: skel_loading 1s linear infinite alternate;

  &.circle {
    border-radius: 100%;
  }
}

@keyframes skel_loading {
  0% {
    background-color: #e8e8f9;
  }
  100% {
    background-color: #f3f3fc;
  }
}
</style>
